import { CarRequiredAttributes } from './carDataAttributes';
import { ComicRequiredAttributes } from './comicDataAttributes';
import { WatchRequiredAttributes } from './watchDataAttributes';
import { OtherRequiredAttributes } from './otherDataAttributes';
import { ArtRequiredAttributes } from './artDataAttributes';
import { AntiqueRequiredAttributes } from './antiqueDataAttributes';
import { BookRequiredAttributes } from './bookDataAttributes';
import { CameraRequiredAttributes } from './cameraDataAttributes';
import { FirearmRequiredAttributes } from './firearmDataAttributes';
import { HandbagRequiredAttributes } from './handbagDataAttributes';
import { JewelryRequiredAttributes } from './jewelryDataAttributes';
import { ToyRequiredAttributes } from './toyDataAttributes';
import { SportsCardRequiredAttributes } from './sportsCardDataAttributes';
import { VinylRecordRequiredAttributes } from './vinylRecordDataAttributes';
import { CoinRequiredAttributes } from './coinDataAttributes';
import { StampRequiredAttributes } from './stampDataAttributes';
import { HistoricalMemRequiredAttributes } from './historicalMemorabiliaDataAttributes';
import { MovieMemRequiredAttributes } from './movieMemorabiliaDataAttributes';
import { MusicalInstrumentRequiredAttributes } from './musicalInstrumentDataAttributes';
import { MusicMemRequiredAttributes } from './musicMemorabiliaDataAttributes';
import { SportsMemRequiredAttributes } from './sportsMemorabiliaDataAttributes';
import { WineRequiredAttributes } from './wineDataAttributes';

const attributes = {
  WATCH: WatchRequiredAttributes,
  CAR: CarRequiredAttributes,
  COMIC: ComicRequiredAttributes,
  COIN: CoinRequiredAttributes,
  STAMP: StampRequiredAttributes,
  OTHER: OtherRequiredAttributes,
  ART: ArtRequiredAttributes,
  ANTIQUE: AntiqueRequiredAttributes,
  BOOK: BookRequiredAttributes,
  CAMERA: CameraRequiredAttributes,
  FIREARM: FirearmRequiredAttributes,
  HANDBAG: HandbagRequiredAttributes,
  JEWELRY: JewelryRequiredAttributes,
  TOY: ToyRequiredAttributes,
  SPORTS_CARD: SportsCardRequiredAttributes,
  VINYL_RECORD: VinylRecordRequiredAttributes,
  MUSICAL_MEM: MusicMemRequiredAttributes,
  SPORTS_MEM: SportsMemRequiredAttributes,
  HISTORIC_MEM: HistoricalMemRequiredAttributes,
  MOVIE_MEM: MovieMemRequiredAttributes,
  MUSICAL_INST: MusicalInstrumentRequiredAttributes,
  WINE: WineRequiredAttributes,
};

export default attributes;



// WEBPACK FOOTER //
// ./src/config/requiredAttributes.js